/*globals module */
const _ = require('lodash');

const widgets = [
  {
    title: 'Manufacturer',
    name: 'brand',
    field: 'brand.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Hauptkategorie',
    name: 'tag_primary',
    field: 'tag_primary.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Unterkategorie',
    name: 'tag_secondary',
    field: 'tag_secondary.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Dosage Form',
    name: 'darreichungsform',
    field: 'darreichungsform.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Flavor',
    name: 'geschmack_filter',
    field: 'geschmack_filter.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
/*  {
    title: 'Hauptzutat / Wirkstoff',
    name: 'ingredients',
    field: 'ingredients.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },*/
  {
    title: 'Price',
    name: 'price_slider',
    filterName: 'price_range',
    field: 'price',
    type: 'slider',
    options: {
      max: 76
    }
  },
  {
    title: 'Price',
    name: 'price_range',
    filterName: 'price_range',
    field: 'price',
    type: 'range',
    options: {
      ranges: [{ from: 0, to: 10 }, { from: 10, to: 25 }, { from: 25, to: 50 }, { from: 50, to: 75 }, { from: 75 }]
    }
  },
  {
    title: 'Diet',
    name: 'ernaehrungsform',
    field: 'ernaehrungsform.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Distinction',
    name: 'auszeichnung',
    field: 'auszeichnung.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Free of',
    name: 'frei_von',
    field: 'frei_von.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Time of Intake',
    name: 'einnahmezeitpunkt',
    field: 'einnahmezeitpunkt.raw',
    operator: 'AND',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Product Size',
    name: 'produktinhalt',
    field: 'produktinhalt.raw',
    operator: 'AND',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'offer',
    name: 'offer_type',
    field: 'offer_type.raw',
    operator: 'AND',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Ratings',
    name: 'averageRating',
    field: 'averageRating',
    type: 'range',
    options: {
      ranges: [{ from: 4, to: 5 }, { from: 3, to: 5 }]
    }
  },
  {
    title: 'Skin Type',
    name: 'hauttyp',
    field: 'hauttyp.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  },
  {
    title: 'Age Group',
    name: 'age_suitability',
    field: 'age_suitability.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  }, {
    title: 'Content',
    name: 'food_content_type',
    field: 'food_content_type.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  }, {
    title: 'Stadium',
    name: 'stadium',
    field: 'stadium.raw',
    operator: 'OR',
    type: 'term',
    options: {
      order: {
        field: '_term',
        type: 'asc'
      }
    }
  }
];

const prominentFilters = [
  {
    name: "auszeichnung",
    value: "Bio",
    label: "Bio",
  },
  {
    name: "offer_type",
    value: "Sale",
    label: "Sale",
  }
];

/**
 * get sorted list of filters
 *
 * @param {string} storeCode
 * @returns {Array}
 */
function getSortedFilters(storeCode) {
  const filtersSorting = _getFilterSorting(storeCode)
  return filtersSorting.filter(element => typeof _.find(widgets, { name: element }) !== 'undefined').map(element => _.find(widgets, { name: element }))
}

/**
 * get the sorting order of filters
 *
 * @param {string} storeCode
 * @returns {Array}
 */
function _getFilterSorting(storeCode) {
  const possibleFilters = JSON.parse(process.env.FILTERS_ORDER);
  return possibleFilters[storeCode] || possibleFilters['GLOBAL'];
}

module.exports = {
  widgets,
  promotedFilters: prominentFilters,
  getSortedFilters
}
